import { Button, Heading, Square, SvgX } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { Modal } from 'src/components/Modal/Modal';
import { BusinessDetailsForm } from 'src/components/selfService/features/Signup/steps/BusinessDetailsStep/BusinessDetailsStep';
import { SelfServiceCorp } from 'src/types/Corp';

interface IEditCorpModalProps {
  corpId: string;
  onCloseModal: () => void;
  onSuccess: () => void;
  onError: () => void;
  corpInfo: SelfServiceCorp;
}

export function EditCorpModal({
  corpId,
  onCloseModal,
  onSuccess,
  onError,
  corpInfo,
}: IEditCorpModalProps): JSX.Element {
  return (
    <>
      <Modal size="sm">
        <Square as="header" dimension="2" width="100%">
          <Button
            variant="tertiary"
            className="closeModalButton"
            type="button"
            onClick={onCloseModal}
          >
            <SvgX size="24px" />
          </Button>
          <Square inset="md">
            <Heading variant="h1">Edit business details</Heading>
          </Square>
        </Square>
        <Square position="relative">
          <BusinessDetailsForm
            corpInfo={corpInfo}
            onError={onError}
            onSuccess={onSuccess}
            onCancel={onCloseModal}
            corpId={corpId as string}
            hasDisabledBusinessIdentityFields={false}
            isAccount
          />
        </Square>
      </Modal>
    </>
  );
}
